module.exports = __webpack_public_path__ + "img/selected6-min.fb4fc2c7.png";